import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Alert } from '@/components/Icons/Alert';
import { Error } from '@/components/Icons/Error';
import { cn } from '@/lib/utils';
export var ToastType;
(function (ToastType) {
    ToastType["attention"] = "attention";
    ToastType["warning"] = "warning";
})(ToastType || (ToastType = {}));
const IconsByState = {
    attention: _jsx(Alert, {}),
    warning: _jsx(Error, {}),
};
export const Toast = ({ toast, onRemove, timeToRemove }) => {
    const [show, setShow] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);
    useEffect(() => {
        const timerShow = setTimeout(() => setShow(true), 400);
        const timerFadeOut = setTimeout(() => setFadeOut(true), timeToRemove - 1000);
        const timerRemove = setTimeout(() => onRemove(toast.id), timeToRemove);
        return () => {
            clearTimeout(timerShow);
            clearTimeout(timerFadeOut);
            clearTimeout(timerRemove);
        };
    }, [onRemove, timeToRemove, toast.id]);
    if (!show) {
        return null;
    }
    const getToastStyles = () => {
        const baseStyles = 'inline-flex items-center justify-center rounded-lg gap-2 w-full animate-fade-in px-2 py-2 max-w-md';
        const typeStyles = {
            attention: 'bg-bg-warning-soft',
            warning: 'bg-bg-destructive-soft',
        };
        const fadeOutStyle = fadeOut ? 'animate-fade-out' : '';
        return cn(baseStyles, typeStyles[toast.type], fadeOutStyle);
    };
    return (_jsxs("div", { className: getToastStyles(), children: [_jsx("span", { children: IconsByState[toast.type] }), _jsx("p", { className: "text-sm", children: toast.message })] }));
};
